import { render, staticRenderFns } from "./InstanceStatsHistory.vue?vue&type=template&id=12955a29&"
import script from "./InstanceStatsHistory.vue?vue&type=script&lang=ts&"
export * from "./InstanceStatsHistory.vue?vue&type=script&lang=ts&"
import style0 from "./InstanceStatsHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports